"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class LayoutWidgetHeader extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getPreview", () => {
      let _this$props = this.props,
          formData = _this$props.formData,
          imageUrl = _this$props.imageUrl,
          icon = _this$props.icon,
          image = _this$props.image,
          name = _this$props.name,
          title = _this$props.title,
          description = _this$props.description,
          widgetType = _this$props.widgetType,
          widgetSize = _this$props.widgetSize;

      if (formData && formData.icon) {
        icon = formData.icon;
      }

      if (formData && formData.image && formData.image.media && formData.image.media.imageUrl) {
        imageUrl = formData.image.media.imageUrl;
      }

      if (formData && formData.widgetType) {
        widgetType = formData.widgetType;
      }

      if (formData && formData.widgetSize) {
        widgetSize = formData.widgetSize;
      }

      return _extends({}, this.props, {
        widgetSize: widgetSize,
        widgetType: widgetType,
        icon: icon,
        imageUrl: imageUrl,
        title: title,
        description: description
      });
    });
  }

  render() {
    const _this$getPreview = this.getPreview(),
          expanded = _this$getPreview.expanded,
          widgetType = _this$getPreview.widgetType,
          imageUrl = _this$getPreview.imageUrl,
          icon = _this$getPreview.icon,
          name = _this$getPreview.name,
          title = _this$getPreview.title,
          description = _this$getPreview.description;

    return _react.default.createElement(_.WidgetHeader, {
      expanded: expanded
    }, _react.default.createElement(_.WidgetMedia, {
      widgetType: widgetType,
      name: title || name,
      imageUrl: imageUrl,
      icon: icon
    }), _react.default.createElement(_.WidgetTitle, {
      title: title || name
    }), _react.default.createElement(_.WidgetDescription, {
      description: description
    }));
  }

}

_defineProperty(LayoutWidgetHeader, "defaultProps", {
  id: false,
  expanded: false
});

var _default = LayoutWidgetHeader;
exports.default = _default;
module.exports = exports.default;